import { Injectable } from '@angular/core';

/**
 * A set of methods for transformation of slide value.
 * Slide value can be boolean (determinate) or boolean + null (indeterminate).
 */
export interface SlideToggleValueUtil {
    getValueByPosition(pos: number): SlideToggleValue;

    toggleValue(currentState: SlideToggleValue): SlideToggleValue;

    getDefaultValue(): SlideToggleValue;

    moveRight(currentState: SlideToggleValue): SlideToggleValue;

    moveLeft(currentState: SlideToggleValue): SlideToggleValue;
}

export type SlideToggleDeterminateValue = boolean;

export type SlideToggleIndeterminateValue = boolean | null;

export type SlideToggleValue = SlideToggleDeterminateValue | SlideToggleIndeterminateValue;

@Injectable({ providedIn: 'root' })
export class SlideToggleDeterminateValueUtil implements SlideToggleValueUtil {
    getValueByPosition(pos: number): SlideToggleDeterminateValue {
        if (pos >= 50) {
            return true;
        }
        if (pos < 50) {
            return false;
        }
    }

    toggleValue(value: SlideToggleDeterminateValue): SlideToggleDeterminateValue {
        return !value;
    }

    getDefaultValue(): SlideToggleValue {
        return false;
    }

    moveLeft(currentState: SlideToggleDeterminateValue): SlideToggleValue {
        return false;
    }

    moveRight(currentState: SlideToggleDeterminateValue): SlideToggleValue {
        return true;
    }
}

@Injectable({ providedIn: 'root' })
export class SlideToggleIndeterminateValueUtil implements SlideToggleValueUtil {
    getValueByPosition(pos: number): SlideToggleIndeterminateValue {
        if (pos >= 75) {
            return true;
        }
        if (pos <= 25) {
            return false;
        }
        return null;
    }

    toggleValue(value: SlideToggleDeterminateValue): SlideToggleDeterminateValue {
        switch (value) {
            case null:
            default:
                return false;
            case true:
                return null;
            case false:
                return true;
        }
    }

    getDefaultValue(): SlideToggleValue {
        return null;
    }

    moveLeft(currentState: SlideToggleValue): SlideToggleValue {
        switch (currentState) {
            default:
            case null:
            case false:
                return false;
            case true:
                return null;
        }
    }

    moveRight(currentState: SlideToggleValue): SlideToggleValue {
        switch (currentState) {
            default:
            case null:
            case true:
                return true;
            case false:
                return null;
        }
    }
}
